import React, { useEffect, useState } from "react";
import { BsQuestionCircle } from "react-icons/bs"
import BackComponent from "../../../components/BackArrow";
import WebService, { BASE_URL } from "../../../utility/WebService";
import Grid, { GridColumn, GridHeader, GridRow } from "../../../components/Grid/Grid";
import { FiDownload } from "react-icons/fi";
import { Controller, useForm } from "react-hook-form";
import CustomDatePicker from "../../../components/DatePicker/CustomDatePicker";
import moment from "moment";

const headers: GridHeader[] = [
    {
        title: "Name of Advisor",
        classTitle:'text-start'
    },
    {
        title: "Agreement Signed",
        class:'text-center'
    },
    {
        title: "Action",
        class: "text-center"
    },
];

const AgreementReport = () => {
    const {
        handleSubmit,
        reset,
        control,
        setValue,
        watch,
        formState: { errors },
    } = useForm();
    const watchAllFields = watch();
    const [rows, setRows] = useState<GridRow[]>([]);
    const [totalCount, setTotalCount] = useState(0);
    const [ShowLoader, setShowLoader] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [startDate, setStartDate] = useState<any>()
    const [endDate, setEndDate] = useState<any>()
    useEffect(() => {
        var endDates = new Date();
        setValue("to_date", endDates)
        setEndDate(endDates)

        var date = new Date();
        const startDate = new Date(date.getTime())
        startDate.setMonth(date.getMonth() - 1)
        setValue("from_date", startDate)

        setStartDate(startDate) 
        getAgreement(1)
    }, [])

    const getAgreement = (page?: Number, value?:any ) => {
        setRows([])
        setTotalCount(0)
        setShowLoader(true)
        var from_date = value != 'CLEAR' ? watchAllFields.from_date ? moment(watchAllFields.from_date).format('YYYY-MM-DD') : '' : ''
        var to_date = value != 'CLEAR' ? watchAllFields.to_date ? moment(watchAllFields.to_date).format('YYYY-MM-DD') : '' : ''
        WebService.postAPI({
            action: `/v2/ClientAgreements/GetAgreementReportList?page=${page}&from_date=${from_date}&to_date=${to_date}&keyword=${searchText}`,
            body: null
        })
            .then((res: any) => {
                setTotalCount(res.total_count);
                setShowLoader(false);
                if (res.list.length > 0) {
                    let rows: GridRow[] = [];
                    for (var i in res.list) {
                        let columns: GridColumn[] = [];
                        columns.push({ value: res.list[i].company_name ? res.list[i].company_name : "-" });
                        columns.push({ value: res.list[i].agreement_count ? res.list[i].agreement_count : "-" });
                        columns.push({ value: actionList(res.list[i]) });
                        rows.push({ data: columns });
                    }
                    setRows(rows);
                }
            })
            .catch((e) => {
                setShowLoader(false);
            })
    }

    const actionList = (value: any) => {
        return (
            <div>
                <a onClick={() => window.open(`${BASE_URL}` + `${`/v2/ClientAgreements/DownloadAllClientAgreementList?id=${value.company_master_id}&from_date=${startDate ? moment(startDate).format('YYYY-MM-DD') : ''}&to_date=${endDate ? moment(endDate).format('YYYY-MM-DD') : ''}`}`)} className="text-brand cursor-pointer" title="Download"><FiDownload size={20} className="inline" /></a>
            </div>
        )
    }

    const onSorting = (currentPage: number) => {
        getAgreement(currentPage);
    };


    // const onClearFilter = () => {
    //     reset()
    //     setStartDate("reset")
    //     setEndDate("reset")
    //     setValue('from_date', '')
    //     setValue('to_date', '')
    //     setTotalCount(0)
    //     getAgreement(0, 'CLEAR')
    //     var arr: any = [];
    //     setRows([...arr])
    // }

    const onApplyFilter = () => {
        getAgreement(0)

    }

    return (
        <>
            <div className="page-content-wraper">
                <div className="grid grid-cols-2 gap-4 mb-3">
                    <div><BackComponent title={'Agreement Report'} />
                    </div>

                    <div className="text-right flex justify-end items-center">
                        <button type="button" className="btn bg-white px-3 py-1 rounded-md hover:shadow-xl  shadow-sm mr-3" title="Help">
                            <BsQuestionCircle size={20} className="inline mr-1" /> Help
                        </button>
                    </div>
                </div>

                <div className="table-card">
                    <form onSubmit={handleSubmit(onApplyFilter)}>
                        <div className=" grid grid-cols-12 filter-wrap mb-3">
                              <div className="flex col-span-2">
                            <div className="w-64 ">
                                <label className="sr-only">Search</label>
                                <div className="relative w-64">
                                    <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                        <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fill-rule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clip-rule="evenodd" />
                                        </svg>
                                    </div>
                                    <input id="search" name="search" className="block w-full table-search-filter" placeholder="Search" type="search" value={searchText} onChange={(e) => setSearchText(e.target.value)}
                                        />
                                </div>
                            </div>
                        </div>

                            <div className="col-span-4 flex form-style">
                                <div>
                                    <Controller
                                        control={control}
                                        name="from_date"
                                        render={({ field }) => (
                                            <CustomDatePicker
                                                selected={startDate}
                                                placeholderText="From Date"
                                                onChange={(data: any) => {
                                                    field.onChange(data);
                                                    setStartDate(data)
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                                &nbsp; &nbsp;
                                <div className="ml-2">
                                    <Controller
                                        control={control}
                                        name="to_date"
                                        render={({ field }) => (
                                            <CustomDatePicker
                                                selected={endDate}
                                                placeholderText="To Date"
                                                onChange={(data: any) => {
                                                    field.onChange(data);
                                                    setEndDate(data)
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                            <div className=" col-span-6 flex items-center  text-right justify-end ">
                                <button type="submit" className="btn btn-brand">Apply</button>
                                {/* <button onClick={onClearFilter} type="button" className="btn btn-white border ml-3">Clear</button> */}
                            </div>


                        </div>
                    </form>

                    <div className="table-card">
                        <Grid
                            headers={headers}
                            rows={rows}
                            ShowLoader={ShowLoader}
                            errorMessage={"No Agreement Report"}
                            count={totalCount}
                            onPageChange={onSorting}
                        />
                    </div>
                </div>
            </div >
        </>
    )
}
export default AgreementReport;